import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';
import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import { InviteOrganizationMemberDto, UpdateOrganizationMemberDto, UpdateOrganizationBillingPlanDto, CreateOrganizationResult, UpdateOrganizationDto, OrganizationMember } from '@/@types/Organization';

const VuexModule = createModule({
  namespaced: 'theoryApiOrganizationsStore',
  strict: false,
});

export class OrganizationsStore extends VuexModule {
  private readonly organizationsRepository = RepositoryFactory.theoryApi.organizationsRepository();
  private organizationMembers: OrganizationMember[] = [];
  private organization: CreateOrganizationResult | undefined = undefined;

  @mutation
  private setOrganizationMembers(organizationMembers: OrganizationMember[] | undefined) {
    if (organizationMembers) {
      this.organizationMembers = organizationMembers;
    }
  }

  @mutation
  private setOrganization(organization: CreateOrganizationResult) {
    this.organization = organization;
  }

  @mutation
  private updateBillingPlan(billingPlan:string) {
    this.organization!.billingPlan = billingPlan;
  }

  /**組織詳細取得 */
  @action
  async findOneOrganization(organizationId: number) {
    const organization = await this.organizationsRepository.findOneOrganization(organizationId);
    if (organization) {
      this.setOrganization(organization);
    }
  }

  /** 組織メンバー招待 */
  @action
  async inviteOrganizationMember(inviteOrganizationMemberDto: InviteOrganizationMemberDto) {
    await this.organizationsRepository.inviteOrganizationMember(inviteOrganizationMemberDto);
  }

  /** 組織メンバー更新 */
  @action
  async updateOrganizationMember(updateOrganizationMemberDto: UpdateOrganizationMemberDto) {
    await this.organizationsRepository.updateOrganizationMember(updateOrganizationMemberDto);
    // TODO: 更新後最新の組織メンバーを取得してステート更新
  }

  /**組織課金プラン変更API */
  @action
  async updateOrganizationBillingPlan(param: { organizationId: number, updateOrganizationBillingPlanDto: UpdateOrganizationBillingPlanDto; }) {
    await this.organizationsRepository.updateOrganizationBillingPlan(param.organizationId, param.updateOrganizationBillingPlanDto);
    this.updateBillingPlan(param.updateOrganizationBillingPlanDto.billingPlan);
  }

  /** 組織メンバー一覧取得 */
  @action
  async fetchOrganizationMembers(params: { organizationId: number, findKeyword: string; }) {
    const organizationMembers = await this.organizationsRepository.getOrganizationMembers(params.organizationId, params.findKeyword);
    this.setOrganizationMembers(organizationMembers);
    return organizationMembers;
  }

  /** 組織更新 */
  @action
  async updateOrganization(params: { organizationId: number, updateOrganizationDto: UpdateOrganizationDto; }) {
    if (params.updateOrganizationDto.organizationComment !== null && params.updateOrganizationDto.organizationComment.length === 0) {
      params.updateOrganizationDto.organizationComment = null;
    }
    if (params.updateOrganizationDto.organizationEmail !== null && params.updateOrganizationDto.organizationEmail.length === 0) {
      params.updateOrganizationDto.organizationEmail = null;
    }
    if (params.updateOrganizationDto.organizationPhoneNumber !== null && params.updateOrganizationDto.organizationPhoneNumber.length === 0) {
      params.updateOrganizationDto.organizationPhoneNumber = null;
    }
    if (params.updateOrganizationDto.organizationPerson !== null && params.updateOrganizationDto.organizationPerson.length === 0) {
      params.updateOrganizationDto.organizationPerson = null;
    }
    if (params.updateOrganizationDto.organizationStreetAddress !== null && params.updateOrganizationDto.organizationStreetAddress.length === 0) {
      params.updateOrganizationDto.organizationStreetAddress = null;
    }
    await this.organizationsRepository.updateOrganization(params.organizationId, params.updateOrganizationDto);
    this.setOrganization({
      organizationId: params.organizationId,
      organizationName: params.updateOrganizationDto.organizationName,
      organizationIcon: params.updateOrganizationDto.organizationIcon,
      organizationComment: params.updateOrganizationDto.organizationComment ? params.updateOrganizationDto.organizationComment : '',
      sectorCd: params.updateOrganizationDto.sectorCd,
      billingPlan: this.organization ? this.organization.billingPlan : '',
      organizationEmail: params.updateOrganizationDto.organizationEmail ? params.updateOrganizationDto.organizationEmail : '',
      organizationPhoneNumber: params.updateOrganizationDto.organizationPhoneNumber ? params.updateOrganizationDto.organizationPhoneNumber : '',
      organizationPerson: params.updateOrganizationDto.organizationPerson ? params.updateOrganizationDto.organizationPerson : '',
      prefectureCd: params.updateOrganizationDto.prefectureCd,
      cityCd: params.updateOrganizationDto.cityCd,
      organizationStreetAddress: params.updateOrganizationDto.organizationStreetAddress ? params.updateOrganizationDto.organizationStreetAddress : '',
      deleteFlag: false,
    });
  }

  get getOrganizationMembers() {
    return this.organizationMembers;
  }
  get getOrganization() {
    return this.organization;
  }
}
